document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('.what-is-bph');
	const toggleButton = container?.querySelector('.what-is-bph__toggle-button');
	const states = container?.querySelectorAll('.what-is-bph__state');

	if (!container || !toggleButton || !states?.length) {
		return;
	}

	function updateStates(isEnlarged) {
		container.classList.remove('what-is-bph--normal', 'what-is-bph--enlarged');
		container.classList.add(isEnlarged ? 'what-is-bph--enlarged' : 'what-is-bph--normal');

		states.forEach((state, index) => {
			const isFirstState = index === 0;
			state.setAttribute('aria-hidden', isFirstState === isEnlarged);
		});

		const srText = toggleButton.querySelector('.sr-text');
		if (srText) {
			srText.textContent = isEnlarged ? 'View Normal State' : 'View Enlarged State';
		}

		toggleButton.setAttribute(
			'aria-label',
			isEnlarged ? 'Switch to Normal Prostate view' : 'Switch to Enlarged Prostate view',
		);
	}

	const initialState = !states[0].hasAttribute('aria-hidden');
	updateStates(initialState);

	toggleButton.addEventListener('click', () => {
		const isCurrentlyEnlarged = container.classList.contains('what-is-bph--enlarged');
		updateStates(!isCurrentlyEnlarged);
	});
});
